// convertData.js
const OptionConvert = (data, label, value, data1,data2, data3,data4, data5) => {
    return data?.map(item => ({
      label: item[label],
      value: item[value],
      [data1]: item[data1],
      [data2]: item[data2],
      [data3]: item[data3],
      [data4]: item[data4],
      [data5]: item[data5]
    }));
  };
  
  export default OptionConvert;
  